import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useStore} from "vuex";
import {computed, onMounted} from 'vue'
import LogDialog from "@/components/LogDialog.vue";
import {useRoute} from "vue-router";
import 'material-design-icons-iconfont/dist/material-design-icons.css'



export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const user = computed(() => store.state.user.user)

const currentRoute = useRoute();
console.log(currentRoute.path)
console.log(JSON.stringify(store.state.user))

// 隐藏手机号中间四位
const formatMobile = (mobile: string) => {
  if (!mobile) {
    return '';
  }
  return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

// 隐藏姓名部分字符，假设隐藏姓氏之后的字符
const formatName = (name: string) => {
  if (!name) {
    return '';
  }
  if (name.length <= 1) {
    return '*';
  } else if (name.length === 2) {
    return name[0] + '*';  // 姓名长度为2时，隐藏名字部分
  } else {
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1]; // 隐藏中间部分字符
  }
}

onMounted(async () => {

});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_watermark = _resolveComponent("el-watermark")!

  return (_openBlock(), _createBlock(_component_el_watermark, {
    class: "page-container",
    content: [formatName(user.value.name), formatMobile(user.value.mobile)],
    "z-index": 9999
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(LogDialog)
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})